"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(theme) {
  return {
    ResendWrapper: {
      backgroundColor: '#E8E8E8',
      color: theme['$text-color'],
      fontFamily: 'quicksand',
      fontWeight: 'bold',
      width: 180,
      fontSize: 13,
      textAlign: 'center',
      margin: 0,
      boxSizing: 'border-box',
      verticalAlign: 'middle',
      lineHeight: 'initial',
      padding: {
        top: 9,
        bottom: 9,
        left: 12,
        right: 14
      },
      border: 0,
      borderRadius: 6,
      userSelect: 'none',
      outline: 'none'
    }
  };
};

exports["default"] = _default;
//# sourceMappingURL=style.js.map